"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _table, _table2;
var _default = exports.default = {
  route: {
    sfe: 'SFE',
    noticemodule: 'Announcement Module',
    notice: 'Announcement',
    noticecontent: 'Announcement Content Detail',
    configuration: 'Configuration',
    district: 'Province/City/District',
    account: 'User',
    messagepush: 'Message Push',
    sfeloginlog: 'SFE Login Log',
    organizationarchitecture: 'Business Org Structure',
    salesarea: 'Sales Area',
    productmodule: 'Product Module',
    material: 'Product',
    materialdetails: 'Product Details',
    storedetails: 'Store Details',
    contractkpimanagement: 'Contract KPI',
    saleskpimanagement: 'Sales KPI',
    reportmodule: 'Performance Reports',
    monthkpi: 'Monthly KPI Report',
    quarterkpi: 'Quarterly KPI Report',
    ordersbymonth: 'Monthly Order Report',
    srstoreorderdetaillist: 'Retail Store Sales Detail',
    carpac: 'CARPARC',
    orderrecommended: 'Order Recommend Detail',
    storedetaillist: 'Store Detail List',
    appversion: 'App Version',
    saledisplaymore: 'PERFORMANCE',
    mixmore: 'MIX',
    newproductsmore: 'NEW PRODUCTS',
    srdetails: 'SR Details',
    kpiset: 'KPI',
    sopnew: 'New Product Total KPI',
    pattenkpi: 'New Pattern KPI',
    sop18: 'MIX Total KPI',
    soptotal: 'Total SOP',
    targetsegmentsop: 'Target Segment SOP',
    producttag: 'Product Tag',
    spnamelist: 'SP Name',
    cpreportmodule: 'CP Performance Reports',
    visitstorestatistics: 'Visit store statistics',
    visitplanstatistics: 'Visit plan statistics',
    customervisitstatistics: 'Customer visit statistics',
    networkexpansionstatistics: 'Network expansion statistics',
    planandtaskstatistics: 'Plan and task statistics',
    planandtaskreport: 'Plan and task performance',
    tasklistbyaddress: 'Regional new store performance',
    planandtasklist: 'Plan and task performance',
    cpplanandtasklist: 'CP Plan and task performance',
    tasklistbysr: 'SR new store performance',
    tasklistbyasm: 'ASM task detail',
    sopamount: 'Revenue SOP',
    aopintegral: 'Score AOP',
    aopamount: 'Revenue AOP',
    daregionaop: 'Region AOP',
    activetotalkpi: 'Total Active Store KPI',
    historyadjust: 'History Revenue Adjust',
    fdmpermission: 'FDM And Region Head Relationship',
    rsmandsp: 'SP Relationship',
    performancemodule: 'Performance Module',
    performancereport: 'Performance Review',
    cpperformancemodule: 'CP Performance Module',
    cpperformancereport: 'CP Performance Review',
    taskmodule: 'Task Module',
    tasklist: 'Task List',
    likecommentmodule: 'Like Comment Module',
    likecommentlist: 'Like Comment List',
    ccikpi: 'CCI KPI',
    srintegralreport: 'SR Integral Report',
    rsmsalesbonusreport: 'Region Head Sales Bonus Report',
    gasnsign: 'GASN Sign',
    likeComment: 'Like Comment List',
    carpacarearefsrinfo: 'Carparc',
    salesperformance: 'Sales Performance Report Total',
    salesperformancecity: 'City Sales Performance Report',
    salesperformancecitytotal: 'City Sales Performance Report Total',
    salesperformancestore: 'Store Sales Performance Report',
    channeldevelopment: 'Channel Development Report',
    workefficiency: 'Work Efficiency Report',
    chatbot: 'chatbot',
    salesreportmodule: 'Sales Detail Report',
    salesreport: 'Sales Detail Report',
    allowancemodule: 'Allowance',
    oilallowance: 'Oil Allowance',
    mealallowance: 'Meal Allowance',
    bailianreport: 'Bailian Report',
    storeonlinetmreport: 'Goodyear e-Shop by Store',
    storeonlineorderreport: 'Goodyear e-Shop by Order',
    fdpreport: 'FDP Report',
    extendedwarrantyresults: 'Extended Warranty Result',
    taskassignment: 'Task Assignment'
  },
  notice: {
    BoxWrap: {
      manage: 'Search Query',
      list: 'Notice List'
    },
    input: {
      appMessageTitle: 'Notice Title',
      appMessageStatus: 'Notice Status',
      startTime: 'Start Date',
      endTime: 'End Date',
      isAuth: 'Authorized Regions'
    },
    table: {
      sequence: 'No.',
      appMessageCode: 'Message ID',
      appMessageTitle: 'Announcement Title',
      noticeImgUrl: 'Messaage Cover',
      appMessageStatus: 'Announcement Status',
      sn: 'Messaage Order',
      startTime: 'Start Date',
      endTime: 'End Date',
      createName: 'Updated by',
      createTime: 'Updated Date',
      action: 'Action'
    },
    dialog: {
      pulish: 'Confirm to publish?',
      unpublish: 'Confirm to unpublish?',
      disable: 'Confirm to archive?'
    },
    message: {
      publishSuccess: 'Publish successful',
      publishFail: 'Publish failed',
      unpublishSuccess: 'Unpublish successful',
      unpublishFail: 'Unpublish failed',
      disableSuccess: 'Archive successful',
      disableFail: 'Archive failed'
    },
    dropdown: {
      editNotice: 'Edit Title',
      editArticle: 'Edit Article',
      viewArticle: 'View Article',
      auth: 'Authorize',
      deleteNotice: 'Delete Notice',
      deleteArticle: 'Delete Article',
      publish: 'Publish',
      unpublish: 'Unpublish',
      disable: 'Archive',
      delete: 'Delete'
    },
    form: {
      appMessageCode: 'Message Code',
      appMessageTitle: 'Message Title',
      noticeImgUrl: 'Message Cover',
      appMessageStatus: 'Message Status',
      sn: 'Message Order',
      startTime: 'Start Date',
      endTime: 'End Date'
    },
    error: {
      appMessageCode: 'Please input message code',
      appMessageTitle: 'Please input message title',
      endTime: 'Please select end date',
      noticeImgUrl: 'Please upload message cover',
      upload: 'Upload failed, please reselect'
    }
  },
  noticeContent: {
    BoxWrap: {
      manage: '',
      cancel: 'Cancel',
      preview: 'Preview'
    },
    input: {},
    table: {},
    dialog: {
      back: 'Confirm to go back to list?？'
    },
    dropdown: {
      mobilePreview: 'Mobile Preview',
      pcPreview: 'PC Preview',
      closePreview: 'Close Preview'
    },
    form: {
      view: 'View:',
      attachment: 'Attachment:'
    },
    error: {
      empty: 'Please input article content'
    }
  },
  configuration: {
    common: {
      E: 'Enabled',
      D: 'Disabled'
    },
    BoxWrap: {
      manage: 'Config Management',
      list: 'Config List'
    },
    input: {
      holder: 'Please input',
      fieldCode: 'Field Code',
      directions: 'Instructions',
      configItemName: 'Field Name',
      configurationType: 'Config Type',
      enableStatus: 'Enable Status'
    },
    form: {
      code: 'Code',
      fieldCode: 'Field Code',
      configItemName: 'Field Name',
      remark: 'Remarks',
      valueCN: 'Value (CN)',
      valueEN: 'Value (EN)'
    },
    table: {
      systemPk: 'No.',
      fieldCode: 'Field Code',
      configItemName: 'Field Name',
      configurationType: 'Config Type',
      configurationValues: 'Config Values',
      enableStatus: 'Enable Status',
      enableTime: 'Enable Time',
      action: 'Action'
    },
    error: {
      configItemName: 'Please input valid field name'
    }
  },
  account: {
    BoxWrap: {
      manage: 'Search Query',
      list: 'User List'
    },
    input: {
      empNo: 'Employee ID',
      username: 'Username (CN)',
      roleCode: 'Role',
      mobile: 'Mobile',
      email: 'Email',
      region: 'Region',
      city: 'City',
      district: 'District',
      address: 'Address',
      accountStatus: 'Enabled/Disabled'
    },
    table: {
      sequence: 'No.',
      empNo: 'Employee ID',
      username: 'Username (CN)',
      usernameCn: 'Username',
      roleCode: 'Role',
      region: 'Region',
      city: 'City',
      district: 'District',
      address: 'Address',
      mobile: 'Mobile',
      email: 'Email',
      accountStatus: 'Enabled/Disabled',
      lastUpdateName: 'Operator',
      lastUpdateTime: 'Operate Time',
      action: 'Action'
    },
    dialog: {},
    dropdown: {
      roleAuth: 'Role Authorization'
    },
    form: {
      empNo: 'Emp No.',
      username: 'Username (CN)',
      usernameCn: 'Username',
      mobile: 'Mobile',
      email: 'Email',
      region: 'Region',
      city: 'City',
      district: 'District',
      address: 'Address',
      accountStatus: 'Enabled/Disabled'
    },
    error: {
      empNo: 'Please input valid emp no.',
      username: 'Please input valid username',
      email: 'Please input valid email',
      mobile: 'Please input valid mobile',
      address: 'Please input valid address'
    }
  },
  reportModule: {
    table: {
      monthKPI_title: 'Monthly Signed Stores',
      quarterKPI_title: 'Quarterly Signed Stores',
      tpp: 'TPP Signed Qty',
      targetSales: 'Target Sales',
      acturlSales: 'Actual Sales',
      targetSales18: '18+ Target Sales',
      acturlSales18: '18+ Actual Sales',
      targetStoreNum: 'Target Signed Stores',
      acturlStoreNum: 'Actual Signed Stores',
      targetActiveStoreNum: 'Target Active Stores',
      acturlActiveStoreNum: 'Actual Active Stores',
      activeStoreNum18: '18+ Active Stores',
      year: ''
    },
    storeDetail: 'Store Detail',
    month: 'Month',
    ordersTable: {
      brand: 'Brand',
      tpp: 'TPP',
      orderNums: 'Monthly Target Sales',
      orderQuat: 'Order Qty',
      confirmQuat: 'Confirmed Qty',
      waitConfirmQuat: 'This Month Unconfirmed',
      historyConfirmQuat: 'History Unconfirmed'
    },
    storeCode: 'Store Code',
    storeName: 'Store Name',
    phone: 'Phone',
    tppCount: 'TPP Signed Qty',
    proviceCity: 'Province/City',
    exportSROrders: 'Export Retail Store Orders',
    storeOrders: {
      storeCode: 'Store Code',
      rtlRegion: 'Province',
      rtlCity: 'City',
      rtlFullName: 'Store Name',
      serviceProviderName: 'Supplier Name',
      empName: 'SR Name',
      rtlRtmCategory: 'RTM Type',
      retailerType: 'Retail Store Type',
      tpp: 'TPP',
      st: 'ST',
      gy18Plus: 'GY 18+',
      january: 'GY Jan',
      february: 'GY Feb',
      march: 'GY Mar',
      april: 'GY Apr',
      may: 'GY May',
      june: 'GY Jun',
      july: 'GY Jul',
      august: 'GY Aug',
      september: 'GY Sep',
      october: 'GY Oct',
      november: 'GY Nov',
      december: 'GY Dec',
      janEighteenActualSalesQty: 'ST Jan',
      febEighteenActualSalesQty: 'ST Feb',
      marEighteenActualSalesQty: 'ST Mar',
      aprEighteenActualSalesQty: 'ST Apr',
      mayEighteenActualSalesQty: 'ST May',
      junEighteenActualSalesQty: 'ST Jun',
      julEighteenActualSalesQty: 'ST Jul',
      augEighteenActualSalesQty: 'ST Aug',
      sepEighteenActualSalesQty: 'ST Sep',
      octEighteenActualSalesQty: 'ST Oct',
      novEighteenActualSalesQty: 'ST Nov',
      decEighteenActualSalesQty: 'ST Dec'
    },
    error: {
      rimSize: 'Please input more than 5 characters in specification query',
      region: 'Please select the province or city'
    },
    startQuarter: 'Start Quarter',
    endQuarter: 'End Quarter',
    quarterError1: 'Start quarter cannot be greater than end quarter',
    quarterError2: 'Time span cannot exceed 2 years',
    filterText: 'Filter',
    carpacTab1: 'Carparc',
    carpacTab2: 'Top Sizes',
    carpacTab3: 'Top Models',
    carparcText: 'Total',
    plus18: '18+',
    plus18Percent: '18+%',
    rimSize: 'Tire Size',
    rim: 'Rim size',
    rimCarparc: 'Carparc',
    top5: 'Top 5 Models',
    mainCarType: 'Main Models',
    sequence: 'Rank',
    salesReport: {
      spName: 'SP Name',
      rsmEmpNo: 'Region Head EmpNo',
      rsmName: 'Region Head Name',
      orderQty: 'Order Qty',
      deliverQty: 'Deliver Qty',
      receiptQty: 'Receipt Qty',
      remark: 'Remark'
    }
  },
  orderRecommended: {
    select: {
      startDay: 'Start Date',
      endDay: 'End Date',
      empNo: 'SR ID',
      empName: 'SR NAME'
    },
    table: {
      srEmpNo: 'SR ID',
      srEmpName: 'SR NAME',
      recommendStoreFrequency: 'Frequency of order recommended stores',
      recommendStoreQty: 'No. of order recommended stores',
      recommendSizeAddQty: 'Recommended SKUs - Accumulated',
      recommendSizeRemoveQty: 'Recommended SKUs - net',
      recommendTireQty: 'Recommended Tires',
      viewStoreAddQty: 'View the Recommendation Stores - Accumulated',
      viewStoreRemoveQty: 'View the Recommendation Stores-net',
      purchaseStoreAddQty: 'Add to Cart Stores - Accumulated',
      purchaseStoreRemoveQty: 'Add to Cart Stores-net'
    }
  },
  appVersion: {
    BoxWrap: {
      manage: 'Version Management'
    },
    button: {
      checkHis: 'View History',
      changeVersion: 'Change Version',
      clearCache: 'Clean Cache',
      upload: 'Click To Upload'
    },
    table: {
      hisList: 'History List',
      displayVersion: 'Version No.',
      versionDesc: 'Version Description',
      downloadUrl: 'Download URL',
      lastUpdateTime: 'Last Update Time',
      createTime: 'Create Time',
      appPlatformType: 'Platform',
      appBizType: 'Biz Type'
    },
    form: {
      uploadApk: 'Upload APK'
    },
    dialog: {
      content1: 'Confirm to set as release version?',
      content2: 'Confirm to clear user cache?',
      releaseSuccess: 'Release successful',
      clearSuccess: 'Clear successful'
    },
    error: {
      appPlatformType: 'Please select',
      displayVersion: 'Please input valid version no.',
      downloadUrl: 'Please upload file',
      versionDesc: 'Please input valid description',
      uploadFail: 'Upload failed, please reselect'
    }
  },
  srDetail: {
    visitStoreNum: 'Store Visit Num',
    number: 'Num',
    time: 'Time',
    storePlan: 'Visit',
    allPlan: 'Total',
    radio: 'ATTN %',
    visitStoreList: 'List',
    all: 'Total',
    storeVisit: 'Visit',
    other: 'Other',
    table: {
      date: 'Date',
      thing: 'Item',
      time: 'Check-in Time',
      store: 'Store',
      monthTimes: 'Visit times this month'
    }
  },
  sopTotal: {
    serviceProviderID: 'SP ID',
    serviceProviderName: 'SP Name',
    salesMonth1: 'Jan Target Sales',
    salesMonth2: 'Feb Target Sales',
    salesMonth3: 'Mar Target Sales',
    salesMonth4: 'Apr Target Sales',
    salesMonth5: 'May Target Sales',
    salesMonth6: 'Jun Target Sales',
    salesMonth7: 'Jul Target Sales',
    salesMonth8: 'Aug Target Sales',
    salesMonth9: 'Sep Target Sales',
    salesMonth10: 'Oct Target Sales',
    salesMonth11: 'Nov Target Sales',
    salesMonth12: 'Dec Target Sales'
  },
  sop18: {
    kpiType: 'KPI Type',
    prodSize: 'Size',
    sales18Month1: 'Jan Target Sales',
    sales18Month2: 'Feb Target Sales',
    sales18Month3: 'Mar Target Sales',
    sales18Month4: 'Apr Target Sales',
    sales18Month5: 'May Target Sales',
    sales18Month6: 'Jun Target Sales',
    sales18Month7: 'Jul Target Sales',
    sales18Month8: 'Aug Target Sales',
    sales18Month9: 'Sep Target Sales',
    sales18Month10: 'Oct Target Sales',
    sales18Month11: 'Nov Target Sales',
    sales18Month12: 'Dec Target Sales'
  },
  targetsegmentsop: {
    kpiType: 'KPI Type',
    salesSUVMonth1: 'Jan SUV Target Sales',
    salesLUXMonth1: 'Jan LUX Target Sales',
    salesEVMonth1: 'Jan EV Target Sales',
    salesSUVMonth2: 'Feb SUV Target Sales',
    salesLUXMonth2: 'Feb LUX Target Sales',
    salesEVMonth2: 'Feb EV Target Sales',
    salesSUVMonth3: 'Mar SUV Target Sales',
    salesLUXMonth3: 'Mar LUX Target Sales',
    salesEVMonth3: 'Mar EV Target Sales',
    salesSUVMonth4: 'Apr SUV Target Sales',
    salesLUXMonth4: 'Apr LUX Target Sales',
    salesEVMonth4: 'Apr EV Target Sales',
    salesSUVMonth5: 'May SUV Target Sales',
    salesLUXMonth5: 'May LUX Target Sales',
    salesEVMonth5: 'May EV Target Sales',
    salesSUVMonth6: 'Jun SUV Target Sales',
    salesLUXMonth6: 'Jun LUX Target Sales',
    salesEVMonth6: 'Jun EV Target Sales',
    salesSUVMonth7: 'Jul SUV Target Sales',
    salesLUXMonth7: 'Jul LUX Target Sales',
    salesEVMonth7: 'Jul EV Target Sales',
    salesSUVMonth8: 'Aug SUV Target Sales',
    salesLUXMonth8: 'Aug LUX Target Sales',
    salesEVMonth8: 'Aug EV Target Sales',
    salesSUVMonth9: 'Sep SUV Target Sales',
    salesLUXMonth9: 'Sep LUX Target Sales',
    salesEVMonth9: 'Sep EV Target Sales',
    salesSUVMonth10: 'Oct SUV Target Sales',
    salesLUXMonth10: 'Oct LUX Target Sales',
    salesEVMonth10: 'Oct EV Target Sales',
    salesSUVMonth11: 'Nov SUV Target Sales',
    salesLUXMonth11: 'Nov LUX Target Sales',
    salesEVMonth11: 'Nov EV Target Sales',
    salesSUVMonth12: 'Dec SUV Target Sales',
    salesLUXMonth12: 'Dec LUX Target Sales',
    salesEVMonth12: 'Dec EV Target Sales'
  },
  pattenkpi: {
    rsmId: 'Region Head ID',
    rsmName: 'Region Head Name',
    asmId: 'ASM ID',
    asmName: 'ASM Name',
    srId: 'SR ID',
    srName: 'SR Name',
    role: 'Role',
    pattern: 'Pattern',
    region: 'Region',
    salesAMGMonth1: 'Jan AMG Target Sales',
    salesRTMonth1: 'Jan RT Target Sales',
    salesEDMonth1: 'Jan ED Target Sales',
    salesACTMonth1: 'Jan ACT Target Sales',
    salesAMGMonth2: 'Feb AMG Target Sales',
    salesRTMonth2: 'Feb RT Target Sales',
    salesEDMonth2: 'Feb ED Target Sales',
    salesACTMonth2: 'Feb ACT Target Sales',
    salesAMGMonth3: 'Mar AMG Target Sales',
    salesRTMonth3: 'Mar RT Target Sales',
    salesEDMonth3: 'Mar ED Target Sales',
    salesACTMonth3: 'Mar ACT Target Sales',
    salesAMGMonth4: 'Apr AMG Target Sales',
    salesRTMonth4: 'Apr RT Target Sales',
    salesEDMonth4: 'Apr ED Target Sales',
    salesACTMonth4: 'Apr ACT Target Sales',
    salesAMGMonth5: 'May AMG Target Sales',
    salesRTMonth5: 'May RT Target Sales',
    salesEDMonth5: 'May ED Target Sales',
    salesACTMonth5: 'May ACT Target Sales',
    salesAMGMonth6: 'Jun AMG Target Sales',
    salesRTMonth6: 'Jun RT Target Sales',
    salesEDMonth6: 'Jun ED Target Sales',
    salesACTMonth6: 'Jun ACT Target Sales',
    salesAMGMonth7: 'Jul AMG Target Sales',
    salesRTMonth7: 'Jul RT Target Sales',
    salesEDMonth7: 'Jul ED Target Sales',
    salesACTMonth7: 'Jul ACT Target Sales',
    salesAMGMonth8: 'Aug AMG Target Sales',
    salesRTMonth8: 'Aug RT Target Sales',
    salesEDMonth8: 'Aug ED Target Sales',
    salesACTMonth8: 'Aug ACT Target Sales',
    salesAMGMonth9: 'Sep AMG Target Sales',
    salesRTMonth9: 'Sep RT Target Sales',
    salesEDMonth9: 'Sep ED Target Sales',
    salesACTMonth9: 'Sep ACT Target Sales',
    salesAMGMonth10: 'Oct AMG Target Sales',
    salesRTMonth10: 'Oct RT Target Sales',
    salesEDMonth10: 'Oct ED Target Sales',
    salesACTMonth10: 'Oct ACT Target Sales',
    salesAMGMonth11: 'Nov AMG Target Sales',
    salesRTMonth11: 'Nov RT Target Sales',
    salesEDMonth11: 'Nov ED Target Sales',
    salesACTMonth11: 'Nov ACT Target Sales',
    salesAMGMonth12: 'Dec AMG Target Sales',
    salesRTMonth12: 'Dec RT Target Sales',
    salesEDMonth12: 'Dec ED Target Sales',
    salesACTMonth12: 'Dec ACT Target Sales',
    salesMonth1: 'Jan Target Sales',
    salesMonth2: 'Feb Target Sales',
    salesMonth3: 'Mar Target Sales',
    salesMonth4: 'Apr Target Sales',
    salesMonth5: 'May Target Sales',
    salesMonth6: 'Jun Target Sales',
    salesMonth7: 'Jul Target Sales',
    salesMonth8: 'Aug Target Sales',
    salesMonth9: 'Sep Target Sales',
    salesMonth10: 'Oct Target Sales',
    salesMonth11: 'Nov Target Sales',
    salesMonth12: 'Dec Target Sales'
  },
  sopNew: {
    kpiType: 'KPI Type',
    pattern: 'Pattern',
    salesNewProtMonth1: 'Jan New Product Target Sales',
    salesNewProtMonth2: 'Feb New Product Target Sales',
    salesNewProtMonth3: 'Mar New Product Target Sales',
    salesNewProtMonth4: 'Apr New Product Target Sales',
    salesNewProtMonth5: 'May New Product Target Sales',
    salesNewProtMonth6: 'Jun New Product Target Sales',
    salesNewProtMonth7: 'Jul New Product Target Sales',
    salesNewProtMonth8: 'Aug New Product Target Sales',
    salesNewProtMonth9: 'Sep New Product Target Sales',
    salesNewProtMonth10: 'Oct New Product Target Sales',
    salesNewProtMonth11: 'Nov New Product Target Sales',
    salesNewProtMonth12: 'Dec New Product Target Sales'
  },
  productTag: {
    vehicleType: 'Target Segment',
    pattern: 'Pattern',
    materialCode: 'SAP Product ID',
    materialDescription: 'Product Description',
    vehicleTypeSuv: 'SUV',
    vehicleTypeLux: 'LUX',
    vehicleTypeEv: 'EV',
    vehicleTypeNew: 'New Product',
    yearOfNew: 'Year of New',
    patternAmg: 'AMG',
    patternRt: 'RT',
    patternEd: 'ED',
    patternAct: 'ACT',
    productIntegral: 'productIntegral',
    fixedCost: 'fixedCost',
    variableCost: 'variableCost',
    exportProductInfo: 'Export Product Info',
    productInfoFileName: 'Product Info'
  },
  spNameList: {
    spSapId: 'SP ID',
    spFullName: 'SP Name',
    spEnglishName: 'SP English Name',
    spShortNameCn: 'SP Chinese Abbr.'
  },
  planAndTaskReport: {
    newVisitNum: 'No. of new store',
    listTable: {
      a01PlanCount: 'No. of store visit plan',
      a01PlanCountMix: '%of planned store visits',
      a01TaskCount: 'No. of store visit tasks',
      a01TaskCountMix: 'Percentage of store visit tasks',
      a01PlanTime: 'planned store visit duration',
      a01PlanTimeMix: '% of planned store visit duration',
      a01TaskTime: 'Store visit task duration',
      a01TaskTimeMix: '% of store visit task duration',
      a02PlanCount: 'No. of potential stores visit plan',
      a02PlanTime: 'Planned duration for potential stores visit plan',
      a07PlanCount: 'No. of planned visits to service providers/dealers',
      a07TaskCount: 'No. of service provider/dealer visits',
      a07PlanTime: 'Planned duration of SP/Distributor visit pan duration',
      a07TaskTime: 'Service provider/Distributor visit task duration',
      a05PlanCount: 'No. of training programs',
      a05TaskCount: 'No. of training tasks',
      a05PlanTime: 'Training plan duration',
      a05TaskTime: 'Training task duration',
      a06PlanCount: 'No. of meetings planned',
      a06TaskCount: 'No. of meeting tasks',
      a06PlanTime: 'Meeting schedule',
      a06TaskTime: 'Meeting task duration',
      a03PlanCount: 'No. of store hunting plans',
      a03TaskCount: 'No. of store hunting tasks',
      a03PlanTime: 'Store Hunting Plan Duration',
      a03TaskTime: 'Store Hunting Task Duration',
      a04PlanCount: 'No. of Seminar plan',
      a04TaskCount: 'No. of Seminar task',
      a04PlanTime: 'Seminar plan Duration',
      a04TaskTime: 'Seminar task Duration',
      a08PlanCount: 'No. of leave plans',
      a08TaskCount: 'No. of vacation tasks',
      a08PlanTime: 'Vacation plan duration',
      a08TaskTime: 'Vacation mission duration',
      a09PlanCount: 'No. of Other planned',
      a09TaskCount: 'Other tasks',
      a09PlanTime: 'Other plan durations',
      a09TaskTime: 'Other task duration'
    }
  },
  sopAmount: {
    amountType: 'KPI Type',
    currencyType: 'Currency Type',
    targetMonth1: 'Jan Target',
    targetMonth2: 'Feb Target',
    targetMonth3: 'Mar Target',
    targetMonth4: 'Apr Target',
    targetMonth5: 'May Target',
    targetMonth6: 'Jun Target',
    targetMonth7: 'Jul Target',
    targetMonth8: 'Aug Target',
    targetMonth9: 'Sep Target',
    targetMonth10: 'Oct Target',
    targetMonth11: 'Nov Target',
    targetMonth12: 'Dec Target'
  },
  aopAmount: {
    rsmId: 'Region Head ID',
    rsmName: 'Region Head Name',
    currencyType: 'Currency Type',
    q1Target: 'Q1 Target Amount',
    q2Target: 'Q2 Target Amount',
    q3Target: 'Q3 Target Amount',
    q4Target: 'Q4 Target Amount'
  },
  aopIntegral: {
    rsmId: 'Region Head ID',
    rsmName: 'Region Head Name',
    asmId: 'ASM ID',
    asmName: 'ASM Name',
    srId: 'SR ID',
    srName: 'SR Name',
    q1TargetQty: 'Q1 Target',
    q2TargetQty: 'Q2 Target',
    q3TargetQty: 'Q3 Target',
    q4TargetQty: 'Q4 Target'
  },
  historyAdjust: {
    rsmId: 'Region Head ID',
    rsmName: 'Region Head Name',
    amountType: 'KPI Type',
    currencyType: 'Currency Type',
    amountMonth1: 'Jan Actual',
    amountMonth2: 'Feb Actual',
    amountMonth3: 'Mar Actual',
    amountMonth4: 'Apr Actual',
    amountMonth5: 'May Actual',
    amountMonth6: 'Jun Actual',
    amountMonth7: 'Jul Actual',
    amountMonth8: 'Aug Actual',
    amountMonth9: 'Sep Actual',
    amountMonth10: 'Oct Actual',
    amountMonth11: 'Nov Actual',
    amountMonth12: 'Dec Actual'
  },
  activeTotalKpi: {
    targetMonth1: 'Jan Active Target',
    targetMonth2: 'Feb Active Target',
    targetMonth3: 'Mar Active Target',
    targetMonth4: 'Apr Active Target',
    targetMonth5: 'May Active Target',
    targetMonth6: 'Jun Active Target',
    targetMonth7: 'Jul Active Target',
    targetMonth8: 'Aug Active Target',
    targetMonth9: 'Sep Active Target',
    targetMonth10: 'Oct Active Target',
    targetMonth11: 'Nov Active Target',
    targetMonth12: 'Dec Active Target'
  },
  fdmPermission: {
    fdmEmpNo: 'FDM ID',
    fdmEmpName: 'FDM Name',
    rsmEmpNo: 'Region Head ID',
    rsmEmpName: 'Region Head Name'
  },
  RSMAndSP: {
    rsmEmpNo: 'ID',
    rsmEmpName: 'Name',
    roleCode: 'RoleCode',
    spSapId: 'SP ID',
    spFullName: 'SP Name'
  },
  performanceReport: {
    BoxWrap: {
      manage: 'Performance Review'
    },
    tab: {
      newCustomer: 'New Customer',
      visiting: 'Visiting',
      visitPlan: 'Visit Plan',
      customerDistribution: 'Customer Distribution',
      order: 'Order',
      cci: 'E-Store & Scan out',
      warranty: '售出延保',
      month: 'Monthly',
      quarter: 'Quarterly',
      year: 'Yearly'
    },
    select: {
      month: 'month',
      quarter: 'quarter',
      year: 'year',
      week: 'week',
      rsm: 'Region Head Name'
    },
    input: {},
    table: (_table = {
      // common
      srEmpNo: 'SR ID',
      srEmpName: 'SR Name',
      action: 'action',
      // 新客户
      newRegisteroty: 'Newly Registered stores',
      newRegisterConfirmedQty: 'Sales from newly registered stores (MTD)',
      newRegisterConfirmedQty_y: 'Sales from newly registered stores (YTD)',
      newsignQty: 'TPP newly signed Stores',
      newSignConfirmedQty: 'Sales from TPP stores (MTD)',
      newSignConfirmedQty_y: 'Sales from TPP stores (YTD)',
      confirmedQty: 'YTD receive confirmed',
      // 访店行为
      visitQty: 'Retailer Visit days',
      visitDuration: 'Retailer-visit duration',
      visitStoreQty: 'Retailer Visited',
      visitStoreFrequency: 'Frequency of Retailer visiting',
      avgStoreFrequency: 'Average frequency of visiting per store',
      unVisitDuration: 'Non-visit duration',
      unVisitDurationRateString: '% of non-visit duration',
      inventoryStoreFrequency: 'Frequency of Stock Check',
      policyStoreFrequency: 'Frequency  of Policy-explanation',
      warrantyStoreFrequency: 'Frequency  of extended warranty communication',
      // 拜访计划
      planQty: 'Plan days',
      visitPlanQty: 'Visit plan days',
      taskQty: 'Task days',
      visitTaskQty: 'Visit task days'
    }, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_table, "visitStoreFrequency", 'Frequency of retailer visiting'), "z02StoreFrequency", 'Frequency of Z02 visit'), "z02Proportion", '% of Z02'), "prospectsStoreFrequency", 'Frequency of potential stores'), "prospectsProportion", '% of Potential stores'), "gasnStoreFrequency", 'Frequency of GASN'), "gasnProportion", '% of GASN'), "tireStoreFrequency", 'Non-GY/CP Stores Frequency'), "tireProportion", '% of Non-GY/CP Stores'), "visitStoreFrequency", 'Frequency of Retailer visiting'), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_table, "visitStoreQty", 'Retailer Visited'), "activeStoreQty", 'Visited Active stores'), "activeProportion", 'Active stores/Visited stores'), "recommendStoreFrequency", 'Frequency of Order Recommended Stores'), "recommendStoreQty", 'Order Recommended Stores'), "recommendTireQty", 'Recommended Tires'), "purchaseStoreQty", 'Add to Cart Stores'), "purchaseProportion", 'Add to Cart Stores / Recommended Stores'), "registerStoreQty", 'Registered Stores'), "signStoreQty", 'TPP Signed Stores'), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_table, "warrantyStoreQty", 'Participate Scan out Stores'), "eShopStoreCount", 'e store active store'), "unsignWarrantyStoreQty", 'Non TPP Signed Stores with scan out'), "rtmConfirmedQty", 'RTM Sales Volume'), "warrantyQty", 'Scan out qty'), "seventeenWarrantyQty", '17+ Scan out qty'), "openMallStoreCount", 'No.of e stores'), "approvedCount", 'Number of scan out passed review'), "pendingApprovedCount", 'Number of scan out under review'), "notApprovedCount", 'Number of scan out failed review'), (0, _defineProperty2.default)(_table, "totalTireCount", 'e store sales volume'))
  },
  CPPerformanceReport: {
    BoxWrap: {
      manage: 'Performance Review'
    },
    tab: {
      visiting: 'Visiting',
      visitPlan: 'Visit Plan',
      customerDistribution: 'Customer Distribution',
      networkExpansion: 'Network Expansion',
      planTask: 'Plan And Task',
      month: 'Monthly',
      quarter: 'Quarterly',
      year: 'Yearly',
      week: 'Week'
    },
    select: {
      month: 'month',
      quarter: 'quarter',
      year: 'year',
      week: 'week',
      rsm: 'Region Head Name',
      srEmpNo: 'SR ID',
      srEmpName: 'SR Name',
      date: 'Date'
    },
    input: {},
    table: (_table2 = {
      // common
      srEmpNo: 'SR ID',
      srEmpName: 'SR Name',
      action: 'action',
      // 访店行为
      visitQty: 'Retailer Visit days',
      visitDuration: 'Retailer-visit duration',
      visitStoreQty: 'Retailer Visited',
      visitStoreFrequency: 'Frequency of Retailer visiting',
      avgStoreFrequency: 'Average frequency of visiting per store',
      spVisitQty: 'No. of days visiting dealers',
      spVisitDuration: 'Duration of dealer visits',
      unVisitDuration: 'Working hours for non-retail and dealer store visits',
      unVisitDurationRate: '% of working hours for non-retail and dealer store visits',
      unVisitDurationRateString: '% of working hours for non-retail and dealer store visits',
      inventoryStoreFrequency: 'Frequency of Stock Check',
      policyStoreFrequency: 'Frequency of Policy-explanation',
      warrantyStoreFrequency: 'Frequency of extended warranty communication',
      // 拜访计划
      planQty: 'Plan days',
      visitPlanQty: 'Visit plan days',
      taskQty: 'Task days',
      visitTaskQty: 'Visit task days'
    }, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_table2, "visitStoreFrequency", 'Frequency of retailer visiting'), "visitClubQty", 'No. club store visits'), "visitClubFrequency", 'Frequency of club stores'), "visitClubFrequencyMix", '%of club store visit frequency'), "visitCrossStoreQty", 'No. visits to modification stores and chains'), "visitCrossStoreFrequency", 'Frequency of modification stores and chains'), "visitCrossStoreFrequencyMix", '%of visit frequency to modification stores and chains'), "z02StoreQty", 'No. Z02 store visits'), "z02StoreFrequency", 'Frequency of Z02 stores'), "z02StoreFrequencyMix", '%of Z02 store visit frequency'), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_table2, "newStoreCount", 'Total New Card Stores'), "newStoreClubCount", 'New Card Club Store Count'), "newStoreModificationCount", 'New Card Modified or Chain Modified Store Count'), "newStoreBaiLianCount", 'New Card Hundred Refinement Store Count'))
  },
  taskList: {
    BoxWrap: {
      manage: 'Search Query',
      list: 'Task List'
    },
    input: {
      readFlag: 'Read Status',
      srEmpNo: 'SR ID',
      dateRange: 'Create Time Range',
      startTimeHolder: 'Start Time',
      endTimeHolder: 'End Time',
      taskType: 'Task Type'
    },
    table: {
      srEmpNo: 'SR ID',
      srEmpName: 'SR',
      taskFromType: 'Task Source',
      taskType: 'Task Type',
      readFlag: 'Read Status',
      rtlRtmCategory: 'RTM Type',
      retailerType: 'Retailer Type',
      rtlAddress: 'Address',
      rtlFullName: 'Store Name',
      distributionName: 'Assignor',
      nowTime: 'Task Allocation Time',
      signBoardBidFlag: 'Sign Board Bid',
      visitPurpose: 'Visit Purpose',
      dueTime: 'Deadline',
      remark: 'Remark',
      action: 'Action'
    },
    form: {
      srEmpNo: 'SR ID',
      srEmpName: 'SR',
      taskFromType: 'Task Source',
      taskType: 'Task Type',
      readFlag: 'Read Status',
      rtlRtmCategory: 'RTM Type',
      retailerType: 'Retailer Type',
      rtlAddress: 'Address',
      rtlFullName: 'Store Name',
      distributionName: 'Assignor',
      nowTime: 'Task Allocation Time',
      signBoardBidFlag: 'Sign Board Bid',
      visitPurpose: 'Visit Purpose',
      dueTime: 'Deadline',
      remark: 'Remark'
    }
  },
  cciKpi: {
    form: {
      srEmpNo: 'SR ID',
      srEmpName: 'SR Name',
      month: 'Month',
      pcd: 'Province/City/District',
      rtlRtmCategory: 'RTM Type',
      signFlag: 'TPP signed',
      storeName: 'Store Name'
    },
    table: {
      rtlFullName: 'Store Name',
      storeCode: 'Store ID',
      rtlRegion: 'Province',
      rtlCity: 'City',
      rtlDistrict: 'District',
      spSapId: 'SP/Distributor ID',
      spFullName: 'SP/Distributor Name',
      rtlRtmCategory: 'RTM Type',
      signFlag: 'TPP signed',
      retailerType: 'Retailer type',
      srEmpNo: 'SR ID',
      srEmpName: 'SR Name',
      confirmedQty: 'MTD Receive Confirmed',
      warrantyQty: 'No. of Extended Tires',
      seventeenWarrantyQty: '17&+No. of 17+ Extended  Warranty Tires'
    }
  },
  GASNSign: {
    storeCode: 'Store Code',
    storeName: 'Store Name',
    signTimeMix: 'Sign date Start from',
    signTimeMax: 'Sign date End by',
    signEndTimMix: 'Expiration Starts from',
    signEndTimeMax: 'Expiration Ends by',
    status: 'status',
    signTime: 'Sign date',
    signEndTime: 'Expiration'
  },
  LikeComment: {
    sender: 'Sender',
    receiver: 'Receiver',
    startTime: 'Start Time',
    endTime: 'End Time',
    originType: 'Origin',
    sendTime: 'Send Time',
    readFlag: 'Flag',
    messageContent: 'Message Content',
    wholeMessageContent: 'Message Content'
  },
  carpacAreaRefSrInfo: {
    empNo: 'No',
    empName: 'Name'
  },
  taskListByASM: {
    planTaskType: 'Type',
    planTaskFlag: 'Item',
    rtlFullName: 'Store Name',
    customerName: 'Customer Name',
    customerAddress: 'Customer Address',
    visitPurposeOne: 'Visit Purpose One',
    visitPurposeTwo: 'Visit Purpose Two',
    asmVisitPurpose: 'ASM Visit Purpose',
    collaborativeFlag: 'Collaborative Store Visit',
    srEmpNo: 'SR ID',
    srEmpName: 'SR Name',
    remark: 'Remark',
    asmVisitSummary: 'ASM Visit Summary'
  },
  channelDevelopment: {
    srEmpNo: 'SR ID',
    rsmName: 'Region Head NAME',
    asmName: 'ASM NAME',
    srEmpName: 'SR NAME',
    tppStoreTargetYtd: 'TPP signed stores target (YTD)',
    tppSignedYtd: 'TPP signed stores (YTD)',
    activeStoreTargetQtd: 'Active stores target (QTD)',
    activeStoreQtd: 'Active stores (QTD)',
    visitBailianStore: 'Visited or provided feedback bailian stores (QTD)',
    newSefStore: 'Newly opened cards (MTD)',
    newRegisterQty: 'Register stores (QTD)',
    newRegisterConfirmedQty: 'Sales from newly registered stores (MTD)',
    newRegisterConfirmedQty_y: 'Sales from newly registered stores (YTD)',
    newSignQty: 'TPP newly signed Stores',
    newSignConfirmedQty: 'Sales from TPP stores (MTD)',
    newSignConfirmedQty_y: 'Sales from TPP stores (YTD)',
    activeStore: 'Active stores',
    oneYearExpiredGasnStore: 'GASN stores due within one year',
    halfYearExpiredGasnStore: 'GASN stores due within half year',
    overdueGasnStore: 'Overdue GASN stores'
  },
  workEfficiency: {
    srEmpNo: 'SR ID',
    rsmName: 'Region Head NAME',
    asmName: 'ASM NAME',
    srEmpName: 'SR NAME',
    visitQty: 'Retailer-visit stores (MTD)',
    visitDuration: 'Retailer-visit duration (MTD)',
    visitStoreFrequency: 'Frequency of Retailer visiting (MTD)',
    visitStoreQty: 'Retailer Visited (MTD)',
    recommendStoreFrequency: 'Frequency of Retailer recommend (MTD)',
    recommendStoreQty: 'Retailer recommend (MTD)',
    purchaseStoreQty: 'MTD add to cart stores',
    unVisitDuration: 'Non-visit duration (MTD)',
    totalWorkDuration: 'Total work duration (MTD)'
  },
  salesPerformance: {
    month: 'Month',
    srEmpNo: 'SR ID',
    srEmpName: 'SR NAME',
    pc: 'Province/City',
    pcd: 'Province/City/District',
    region: 'Province',
    city: 'City',
    cityAop: 'AOP目标分解',
    aopGap: 'MTD实际与AOP差值',
    district: 'District',
    storeCode: 'Store Code',
    storeName: 'Store Name',
    empName: 'SR NAME',
    retailerType: 'Retail Store Type',
    storeType: 'Store Type',
    tppQty: 'TPP Signed Qty',
    saleQty: 'Qty (MTD)',
    actualEighteenQty: '18+ Qty (MTD)',
    luxQty: 'LUX Qty (MTD)',
    suvQty: 'SUV Qty (MTD)',
    evQty: 'EV Qty (MTD)',
    atcQty: 'ACT Qty (MTD)',
    amgQty: 'AMG Qty (MTD)',
    a6Qty: 'A6 Qty (MTD)',
    newProduct1Qty: 'AMG/AMG SUV EDR Qty (MTD)',
    newProduct2Qty: 'EF1 A6 Qty (MTD)',
    newProduct3Qty: 'EF1 A6 SUV Qty (MTD)',
    newProduct4Qty: 'EDS/ED series Qty (MTD)',
    warrantyQty: '当月延保条数',
    salesIntegral: '当季销售积分值',
    totalSaleQty: 'Total Qty (YTD)',
    m1SaleQty: 'JAN ST',
    m2SaleQty: 'FEB ST',
    m3SaleQty: 'MAR ST',
    m4SaleQty: 'APR ST',
    m5SaleQty: 'MAR ST',
    m6SaleQty: 'JUN ST',
    m7SaleQty: 'JUL ST',
    m8SaleQty: 'AUG ST',
    m9SaleQty: 'SEP ST',
    m10SaleQty: 'OCT ST',
    m11SaleQty: 'NOV ST',
    m12SaleQty: 'DEC ST'
  },
  SRIntegralReport: {
    rsmEmpName: 'Region Head Name',
    asmEmpName: 'ASM Name',
    srEmpNo: 'SR ID',
    srEmpName: 'SR Name',
    month: 'Month',
    integralQty: 'Monthly Points',
    quarterTargetIntegralQty: 'Quarterly Points Target',
    actualActiveStoreQty: 'Active Stores This Month',
    quarterTargetActiveStoreQty: 'Quarterly Active Store Target'
  },
  RSMSalesBonusReport: {
    rsmEmpNo: 'Region Head ID',
    rsmEmpName: 'Region Head Name',
    m1Income: 'January Revenue',
    m2Income: 'February Revenue',
    m3Income: 'March Revenue',
    q1Income: 'Q1 Total Revenue',
    q1TargetQty: 'Q1 Total Revenue Target',
    q1IncomeRate: 'Q1 Total Revenue Achievement Rate',
    q1IncomeRateString: 'Q1 Total Revenue Achievement Rate (%)',
    m4Income: 'April Revenue',
    m5Income: 'May Revenue',
    m6Income: 'June Revenue',
    q2Income: 'Q2 Total Revenue',
    q2TargetQty: 'Q2 Total Revenue Target',
    q2IncomeRate: 'Q2 Total Revenue Achievement Rate',
    q2IncomeRateString: 'Q2 Total Revenue Achievement Rate (%)',
    m7Income: 'July Revenue',
    m8Income: 'August Revenue',
    m9Income: 'September Revenue',
    q3Income: 'Q3 Total Revenue',
    q3TargetQty: 'Q3 Total Revenue Target',
    q3IncomeRate: 'Q3 Total Revenue Achievement Rate',
    q3IncomeRateString: 'Q3 Total Revenue Achievement Rate (%)',
    m10Income: 'October Revenue',
    m11Income: 'November Revenue',
    m12Income: 'December Revenue',
    q4Income: 'Q4 Total Revenue',
    q4TargetQty: 'Q4 Total Revenue Target',
    q4IncomeRate: 'Q4 Total Revenue Achievement Rate',
    q4IncomeRateString: 'Q4 Total Revenue Achievement Rate (%)'
  },
  DARegionAop: {
    BoxWrap: {
      manage: 'Search Query',
      list: 'Region Aop List'
    },
    year: 'Year',
    regionCode: 'Region Code',
    region: 'Region',
    brand: 'Brand',
    oneSalesTargetQty: 'January Sales Target',
    twoSalesTargetQty: 'February Sales Target',
    threeSalesTargetQty: 'March Sales Target',
    fourSalesTargetQty: 'April Sales Target',
    fiveSalesTargetQty: 'May Sales Target',
    sixSalesTargetQty: 'June Sales Target',
    sevenSalesTargetQty: 'July Sales Target',
    eightSalesTargetQty: 'August Sales Target',
    nineSalesTargetQty: 'September Sales Target',
    tenSalesTargetQty: 'October Sales Target',
    elevenSalesTargetQty: 'November Sales Target',
    twelveSalesTargetQty: 'December Sales Target'
  },
  bailianReport: {
    input: {
      date: 'Date',
      feedbackDate: 'Feedback Date',
      baiLianStoreName: 'BailLian StoreName',
      storeBrand: 'Store Brand',
      empNo: 'emp No',
      empName: 'emp Name',
      dataHolder: 'Please select date',
      exportFailed: 'Export Failed'
    },
    exportFileName: 'BailianReport',
    exportSumFileName: 'BailianSumReport',
    baiLianStoreId: 'StoreId',
    baiLianStoreName: 'StoreName',
    baiLianAddress: 'BaiLian Address',
    baiLianProvince: 'BaiLian Province',
    baiLianCity: 'BaiLian City',
    baiLianDistrict: 'BaiLian District',
    baiLianPhone: 'BaiLian Phone',
    businessStatus: 'Business Status',
    score: 'Score',
    storeBrand: 'StoreBrand',
    monthTireSalesAvg: 'Month Tire Sales Avg',
    empNo: 'EmpNo',
    empName: 'EmpName',
    region: 'Region',
    feedbackContent: 'Feedback Content',
    feedbackDay: 'Feedback Day',
    relatedStoreId: 'Related StoreId',
    handleRelatedStoreId: 'Handle Related StoreId',
    rtlSapId: 'rtl SapId',
    rtlFullName: 'rtl FullName',
    rtlAddress: 'rtl Address',
    createTime: 'Create Time',
    latestSubmitDatetime: 'Latest Submit Datetime',
    latestDetailOne: 'Latest Detail One',
    latestDetailTwo: 'Latest Detail Two',
    evaluateRate: 'Evaluate Rate',
    acceptTerms: 'Accept Terms',
    urgentDeliveryTime: 'Urgent Delivery Time',
    regularDeliveryTime: 'Regular Delivery Time',
    willingToRtmOrder: 'Willing To RtmOrder',
    goodContent: 'Good Content',
    badContent: 'Bad Content',
    otherContent: 'Other Content'
  },
  storeonlinetmreport: {
    input: {
      retailerId: 'Retailer ID',
      retailerName: 'Retailer Name',
      empNo: 'Emp No',
      empName: 'Emp Name',
      month: 'Month',
      dataHolder: 'Please select date',
      exportFailed: 'Export Failed'
    },
    exportFileName: 'Goodyear e-Shop by Store',
    exportSumFileName: 'Goodyear e-Shop by Store',
    retailerId: 'Retailer ID',
    retailerName: 'Retailer Name',
    empNo: 'Emp No',
    empName: 'Emp Name',
    orderScanInRtmQty: 'Order ScanIn RtmQty',
    unOrderScanInRtmQty: 'UnOrder ScanIn RtmQty',
    appFinishedSalesQty: 'App Finished SalesQty',
    warrantyApprovedQty: 'Warranty ApprovedQty',
    warrantyToBeReviewedQty: 'Warranty ToBe ReviewedQty',
    unWarrantyApprovedQty: 'UnWarranty ApprovedQty'
  },
  storeonlineorderreport: {
    input: {
      retailerId: 'Retailer ID',
      retailerName: 'Retailer Name',
      orderNo: 'Order No',
      tireOrderNo: 'Tire OrderNo',
      orderCreateTime: 'Order CreateTime',
      finishedTime: 'Finished Time',
      dataHolder: 'Please select date',
      exportFailed: 'Export Failed'
    },
    exportFileName: 'Goodyear e-Shop by Order',
    exportSumFileName: 'Goodyear e-Shop by Order',
    retailerId: 'Retailer ID',
    retailerName: 'Retailer Name',
    orderNo: 'Order No',
    tireOrderNo: 'Tire OrderNo',
    orderCreateTime: 'Order CreateTime',
    finishedTime: 'Finished Time',
    orderLabel: 'Order Label',
    warrantyScanOutQty: 'Warranty ScanOutQty',
    orderScanInQty: 'Order ScanInQty',
    orderSkuQty: 'Order SkuQty'
  },
  fdpreport: {
    input: {
      dataHolder: 'Please select date',
      exportFailed: 'Export Failed',
      retailerId: 'Retailer ID',
      retailerName: 'Retailer Name',
      orderNo: 'Order No',
      createDate: 'Delivery Order Create Time',
      tireOrderNo: 'Warranty Order No',
      orderCreateTime: 'Order Create Time',
      receivedTime: 'Received Time'
    },
    exportFileName: 'fdp',
    exportSumFileName: 'fdp',
    table: {
      sku: 'Sku',
      b2bName: 'B2b Name',
      tireStatus: 'Tire Status',
      orderNo: 'Order No',
      orderType: 'Order Type',
      retailerId: 'Retailer Id',
      retailerName: 'Retailer Name',
      consigneeRetailerName: 'Consignee Retailer Name',
      consigneeAddress: 'Consignee Address',
      stockoutDistance: 'Stockout Distance',
      retailerStoreAddress: 'Retailer Store Address',
      pickedupDistance: 'Pickedup Distance',
      photoDistance: 'Photo Distance',
      deliveryDistance: 'Delivery Distance',
      photoToDeliveryDistance: 'Photo To Delivery Distance',
      auditScore: 'Photo Audit Score',
      auditRemark: 'Photo Audit Remark',
      deliveryDuration: 'Delivery Duration',
      overDueFlag: 'Over Due Flag',
      nickname: 'Nick name',
      createDate: 'Delivery Order Create Time',
      stockoutTime: 'Stockout Time',
      pickedupTime: 'Pickedup Time',
      deliveryTime: 'Delivery Time',
      returnTime: 'Return Time',
      receivedTime: 'Received Time'
    }
  },
  extendedwarrantyresults: {
    input: {
      orderNumber: 'Order Number',
      barCode: 'BarCode',
      qrcode: 'QrCode',
      status: 'Status',
      ruleCodeList: 'Rule List',
      retailerId: 'Retailer ID',
      retailerName: 'Retailer Name',
      createTime: 'Create Time',
      dataHolder: 'Please select date',
      exportFailed: 'Export Failed',
      tireOrderRatingList: 'Tire Order Rating',
      sku: 'SKU',
      sapDescription: 'Sap Description'
    },
    exportFileName: 'Extended Warranty Result',
    exportSumFileName: 'Extended Warranty Result',
    orderNumber: 'Order Number',
    barCode: 'BarCode',
    qrcode: 'QrCode',
    status: 'Status',
    tireOrderRating: 'Tire Order Rating',
    rulesValueListStr: 'Rule List',
    remark: 'Remark',
    lyTireSpecMatchingResult: 'LyTire Matching Result',
    warrantyExtensionReview: 'Warranty Extension Review',
    retailerId: 'Retailer ID',
    retailerName: 'Retailer Name',
    retailerAddress: 'Retailer Address',
    tireItemNo: 'Tire Item No',
    sku: 'SKU',
    tirePosition: 'Tire Position',
    sapDescription: 'Sap Description',
    vin: 'VIN',
    licensePlate: 'LicensePlate',
    brandModule: 'BrandModule',
    tireOrderCreateTime: 'Tire Order CreateTime'
  },
  taskassignment: {
    BoxWrap: {
      manage: '任务分配',
      export: '导出',
      import: '导入'
    },
    input: {
      taskDescription: '任务分配描述',
      rsmEmpNo: 'ASM工号',
      rsmEmpName: 'ASM姓名',
      asmEmpNo: 'ASM工号',
      asmEmpName: 'ASM姓名',
      srEmpNo: 'SR工号',
      srEmpName: 'SR姓名',
      deadlineTime: '截止时间',
      dataHolder: '请选择日期',
      exportFailed: '导出失败'
    },
    table: {
      taskDescription: '任务分配描述',
      allocatedType: '指派类型',
      deadlineTimeFormatte: '截止日期',
      rsmEmpNo: '被指派的RSM工号',
      rsmEmpName: '被指派的RSM名称',
      asmEmpNo: '被指派的ASM工号',
      asmEmpName: '被指派的ASM名称',
      srEmpNo: '被指派的SR工号',
      srEmpName: '被指派的SR名称',
      rtlRtmCategory: 'RTM类型',
      retailerType: '零售店类型',
      spSapId: '服务商编号',
      spFullName: '服务商全称',
      rtlRegion: '省份',
      rtlCity: '城市',
      rtlSapId: '客户编号',
      rtlFullName: '客户名称',
      remark: '备注'
    }
  }
};